import {
  Image,
  Container,
  Title,
  Text,
  Button,
  SimpleGrid,
  rem,

} from "@mantine/core";
import image from "../../assets/image.svg";


export default function NotFoundPage() {


  return (
    <Container>
      <SimpleGrid
        spacing={80}
        cols={2}

      >
        <Image src={image}  />
        <div>
          <Title >Page Not Found...</Title>
          <Text c="dimmed" size="lg">
            ไม่พบหน้าที่ท่านระบุ
          </Text>
        </div>
        <Image src={image}  />
      </SimpleGrid>
    </Container>
  );
}
